import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Calendar, BarChart3, Brain, Video, Lock, Sparkles, Settings, LogOut, Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useTestsCompleted } from '../hooks/useTestsCompleted';
import { SheetClose } from './ui/sheet';

const ITEMS = [
  { to: '/dashboard', icon: LayoutDashboard, fr: 'Tableau de bord', en: 'Dashboard', id: 'dashboard' },
  { to: '/weekly-tracking', icon: Calendar, fr: 'Suivi hebdomadaire', en: 'Weekly tracking', id: 'tracking' },
  { to: '/statistics', icon: BarChart3, fr: 'Statistiques', en: 'Statistics', id: 'statistics' },
  { to: '/exercises', icon: Brain, fr: 'Exercices TCC', en: 'CBT exercises', id: 'exercises' },
  { to: '/videos', icon: Video, fr: 'Vidéos', en: 'Videos', id: 'videos', gated: true },
  { to: '/subscription', icon: Sparkles, fr: 'Abonnement', en: 'Subscription', id: 'subscription' },
  { to: '/settings', icon: Settings, fr: 'Paramètres', en: 'Settings', id: 'settings' },
];

const rowClass = 'flex w-full items-center gap-3 h-12 px-3 rounded-xl text-base font-medium transition-colors';

export const MobileNavMenu = ({ user, onLogout }) => {
  const { language, toggleLanguage } = useLanguage();
  const { allDone } = useTestsCompleted();
  const { pathname } = useLocation();
  const fr = language === 'fr';

  return (
    <div className="flex flex-col h-full pt-2" data-testid="mobile-nav-menu">
      <p className="px-3 text-sm text-gray-500 mb-4">{fr ? 'Bonjour' : 'Hello'}, <span className="font-semibold text-gray-900">{user?.first_name}</span></p>
      <nav className="flex flex-col gap-1">
        {ITEMS.map(({ to, icon: Icon, id, gated, ...label }) => {
          const locked = gated && !allDone;
          if (locked) {
            return (
              <div key={id} className={`${rowClass} text-gray-400`} data-testid={`mobile-nav-${id}-locked`}>
                <Icon className="w-5 h-5" />
                <span className="flex-1">{label[language]}</span>
                <Lock className="w-4 h-4" />
              </div>
            );
          }
          return (
            <SheetClose asChild key={id}>
              <Link
                to={to}
                className={`${rowClass} ${pathname === to ? 'bg-primary/10 text-primary' : 'text-gray-700 hover:bg-gray-100'}`}
                data-testid={`mobile-nav-${id}`}
              >
                <Icon className="w-5 h-5" />
                {label[language]}
              </Link>
            </SheetClose>
          );
        })}
      </nav>
      <div className="mt-auto border-t border-gray-100 pt-3 pb-[max(1rem,env(safe-area-inset-bottom))] flex flex-col gap-1">
        <button onClick={toggleLanguage} className={`${rowClass} text-gray-700 hover:bg-gray-100`} data-testid="mobile-nav-language">
          <Globe className="w-5 h-5" />
          {fr ? 'English' : 'Français'}
        </button>
        <SheetClose asChild>
          <button onClick={onLogout} className={`${rowClass} text-red-600 hover:bg-red-50`} data-testid="mobile-nav-logout">
            <LogOut className="w-5 h-5" />
            {fr ? 'Se déconnecter' : 'Log out'}
          </button>
        </SheetClose>
      </div>
    </div>
  );
};
